import arrowLeft from '../../../assets/icons/arrow-left.svg';
import { useTranslation } from '../../../hooks/useTranslations';
import classes from './BackButton.module.css';

type Props = {
  onClick: () => void;
  disableMargin?: boolean;
  iconOnly?: boolean;
  style?: React.CSSProperties;
};

const BackButton: React.FC<Props> = ({
  onClick,
  disableMargin = false,
  iconOnly = false,
  style,
}) => {
  const { translations } = useTranslation();
  return (
    <div
      className={classes.container}
      style={
        style
          ? { marginLeft: disableMargin ? 0 : 32, ...style }
          : { marginLeft: disableMargin ? 0 : 32 }
      }
      onClick={onClick}
    >
      <img
        className={classes.arrowIcon}
        style={{ marginRight: iconOnly ? 0 : 6 }}
        src={arrowLeft}
        alt="arrowIcon"
      />
      {!iconOnly && <div className={classes.label}>{translations('back')}</div>}
    </div>
  );
};

export default BackButton;
